'use strict';

export class MoleculeGroupPhonecall {
	constructor(component_key) {
		this.id = component_key;
		this.data = yalwa.v.components[component_key];
		this.call_after_login_flag = 'bst_call';
		this.call_after_login_msgid = 'bst_call_msgid';
	}

	init() {
		jQuery('.js-mbody').off('click.phonecall').on('click.phonecall', '.js-molecule_phonecall', (e) => {
			this.handle_call(e);
		});

		if (yalwa.basics.ss_get(this.call_after_login_flag)) {
			this.call_after_login();
		}
	}

	handle_call(e) {
		const $molecule = jQuery(e.currentTarget);

		// this request is not only for getting phone number but tracking, it should be called also for logged-out users.
		this.reveal_and_call($molecule)
			.then(response => {
				if (!yalwa.basics.is_logged_in()) {
					yalwa.basics.ss_set(this.call_after_login_msgid, $molecule.data('msgid'));
					yalwa.mobile.auth
						.register_success_handler(this.call_login_success_handler.bind(this))
						.show_dialog(e);
				}
			});
	}

	call_login_success_handler() {
		yalwa.basics.ss_set(this.call_after_login_flag, true);
		yalwa.basics.reload();
	}

	call_after_login() {
		yalwa.basics.ss_remove(this.call_after_login_flag);

		if (!yalwa.basics.is_logged_in()) {
			return;
		}

		const msgID = yalwa.basics.ss_get(this.call_after_login_msgid);
		yalwa.basics.ss_remove(this.call_after_login_msgid);

		if (!msgID) {
			return;
		}

		const $molecule = jQuery('.js-molecule_phonecall[data-msgid="' + msgID + '"]');
		if ($molecule.length) {
			$molecule.trigger('click');
		}
	}

	reveal_and_call($molecule) {
		const csrf = $molecule.data('csrf');
		const msgID = $molecule.data('msgid');
		const code = $molecule.data('code');
		const key = $molecule.data('key');

		return yalwa.basics.ajaxservice({
			type: 'POST',
			resource: 'posting',
			action: 'reveal_phone',
			csrf: csrf,
			identifier: msgID,
			data: {
				c: code,
				k: key,
				call_button: 'bst_call'
			},
			include_session: true,
			is_cross_origin: true
		}).then(response => {
			if (response && response.success && response.number) {
				yalwa.basics.ga.ping_metric('CM_BST_CALL', 1);
				yalwa.basics.navigate('tel:' + response.number);
			}
			return response;
		});
	}
}
